import styled from 'styled-components';
import { Select } from '@mui/material'

export const SelectStyled = styled(Select)`
    cursor: pointer
`
